import { Card, CardBody, CardHeader, Col, Container, Input, Label, Row, Table } from "reactstrap";
import SweetAlert from 'sweetalert2';
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useVentesListe, { cardVentes, changeStatus, deleteVentes } from "../VenteApi";
import { SearchTableButton } from "../../../utils/Constant";
import { formatDate, formatPhoneNumber, formatPrice, PaginationComponent, truncateText } from "../../../utils/helper/helpers";
import { Btn, H1, H3, H4, H6 } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";

type Vente = { [key: string]: any }

const RHVentes = () => {

    const [filterText, setFilterText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [filteredItems, setFilteredItems] = useState<Vente[]>([]);
    const [refresh, setRefresh] = useState(false);
    const prods = useVentesListe(refresh) || [];

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1; // Mois actuel (1-12)
        let filtered = prods;
        filtered = prods.filter((item) => {
            const itemMonth = new Date(item.date_vente).getMonth() + 1;
            const matchesMonth = selectedMonth ? itemMonth === selectedMonth : itemMonth === currentMonth;
            const matchesSearch = item.name && item.name.toLowerCase().includes(filterText.toLowerCase()) ||
                // item.name && item.name.toLowerCase().includes(filterText.toLowerCase()) ||
                item.phone && item.phone.toLowerCase().includes(filterText.toLowerCase()) ||
                item.numero_de_vent && item.numero_de_vent.toLowerCase().includes(filterText.toLowerCase()) ||
                item.address && item.address.toLowerCase().includes(filterText.toLowerCase());
            return matchesMonth && matchesSearch;
        });

        setFilteredItems(filtered);
    }, [prods, filterText, selectedMonth, refresh]);

    console.log(filteredItems)

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle={'Rapport et Historique'} parent={'Ventes'} />
            <Container fluid>
                {
                    cardVentes({ value: filteredItems })
                }
                <Card>
                    {/* <CardHeader> */}
                        <H3 className="mt-3 text-center">Historiques des ventes</H3>
                    {/* </CardHeader> */}
                    <CardBody>
                        <Row>

                            <Col sm="9">
                                <div className="dataTables_filter d-flex align-items-center">
                                    <Input
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                        placeholder="Rechercher..."
                                        type="search"
                                        value={filterText}
                                    />
                                </div>
                            </Col>
                            <Col sm="3">
                                <Input name="type" value={selectedMonth || ''} onChange={handleMonthChange} type="select" className="form-control">
                                    <option value="">Mois actuel</option>
                                    <option value="1">Janvier</option>
                                    <option value="2">Février</option>
                                    <option value="3">Mars</option>
                                    <option value="4">Avril</option>
                                    <option value="5">Mai</option>
                                    <option value="6">Juin</option>
                                    <option value="7">Juillet</option>
                                    <option value="8">Août</option>
                                    <option value="9">Septembre</option>
                                    <option value="10">Octobre</option>
                                    <option value="11">Novembre</option>
                                    <option value="12">Décembre</option>
                                </Input>
                            </Col>
                        </Row>
                    </CardBody>

                    <Table responsive id="all-invoice" striped={true}>
                        <thead className="bg-info">
                            <tr>
                                <th className="text-white">Id</th>
                                <th className="text-white ps-4">Clients / Téléphone</th>
                                <th className="text-white ">Prix / Nbr Produits</th>
                                <th className="text-white ">Adresse / Date Vente</th>
                                <th className="text-white ">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredItems.map((item, index) => (
                                <tr key={item.id}>
                                    <th scope='row'>
                                        <span className="fw-bold">
                                            #{index + 1}
                                        </span>
                                    </th>
                                    <td>
                                        <span className="fw-bold text-capitalize">
                                            {truncateText(item.name, 20)}
                                        </span><br />
                                        <span>
                                            {formatPhoneNumber(item.phone)}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="fw-bold text-capitalize">
                                            {formatPrice(item.vente_total)}

                                        </span><br />
                                        <span>
                                            {parseInt(item.produit_count).toLocaleString("gn-GN")} Produit.s
                                        </span>
                                    </td>
                                    <td>
                                        <span className="fw-bold text-capitalize">
                                            {item.address}
                                        </span><br />
                                        <span>
                                            {formatDate(item.date_vente)}
                                        </span>
                                    </td>
                                    <td>
                                        <Link to={`${process.env.PUBLIC_URL}/vente-facture/${item.numero_de_vent}`} className='bg-dark btn btn-xs mx-1 my-1'>
                                            <i className='fa fa-eye'></i>
                                        </Link>
                                        {/* <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                            <i className='fa fa-trash'></i>
                                        </Btn> */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {/* <PaginationComponent items={filteredItems} itemsPerPage={1} /> */}
                </Card>
            </Container>
        </div>

    )
}

export default RHVentes